<template>
  <v-card-text>
    <v-col cols="6">
      <v-text-field
        v-model="search"
        prepend-icon="mdi-magnify"
        clearable
        label="Search"
        single-line
        dense
        hide-details
      ></v-text-field>
    </v-col>
    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="invoiceBatches"
      :search="search"
      :loading="loading"
      item-key="invoiceBatchId"
      show-select
      sort-by="batchDate"
      sort-desc
    >
      <template v-slot:[`header.data-table-select`]></template>
      <template
        v-slot:[`item.data-table-select`]="{ item, isSelected, select }"
      >
        <v-simple-checkbox
          :value="isSelected || pendingBatches.includes(item.invoiceBatchId)"
          @input="select($event)"
          :disabled="pendingBatches.includes(item.invoiceBatchId)"
        ></v-simple-checkbox>
      </template>
    </v-data-table>
  </v-card-text>
</template>
<script>
export default {
  props: ["pendingBatches"],
  async mounted() {
    this.loading = true;
    await this.$store.dispatch("billingModule/getAllInvoiceBatches");
    this.loading = false;
  },
  data() {
    return {
      loading: false,
      headers: [
        { text: "Batch ID", value: "invoiceBatchId" },
        { text: "Batch Date", value: "formattedBatchDate" },
        {
          text: "Batch Number",
          value: "batchNumber",
          align: "center",
          sortable: false,
        },
        {
          text: "Invoice Number",
          value: "invoiceNumber",
          align: "center",
          sortable: false,
        },
        {
          text: "Voucher Number",
          value: "voucherNumber",
          align: "center",
          sortable: false,
        },
        {
          text: "Total Billed Amount",
          value: "formattedTotalAmount",
          sortable: false,
        },
      ],
      search: "",
      selected: [],
    };
  },
  computed: {
    invoiceBatches() {
      return (
        this.$store.state.billingModule.invoiceBatches.filter(
          (item) => item.status == "Approved"
        ) || []
      );
    },
  },
  watch: {
    selected: {
      handler() {
        this.$emit("setSelected", this.selected);
      },
    },
  },
};
</script>
